module.exports = __webpack_public_path__ + "img/logo_DOIT.0ab3ff3a.png";